module.exports = __webpack_public_path__ + "img/banner.cb48dada.jpg";